export default __webpack_public_path__ + "static/media/game_paths.04c93e16.png";